import { atom } from 'jotai';

import type { Heidi2OnboardingStep } from '../onboarding/heidi2Onboarding.wizard';

/**
 * Reopens the Heidi II tour part-way in — the explore-later banner and the
 * checklist's "Complete welcome tour" item set it. Cleared when the tour ends.
 *
 * It sits here rather than beside the other Heidi II atoms in `/data` because
 * `Heidi2OnboardingStep` derives from the wizard in this zone, and `/data` may
 * not reach `/ui` even for a type.
 */
export const heidi2OnboardingLaunchAtom = atom<{ startAt: Heidi2OnboardingStep } | null>(
  null
);
